import axios from 'axios';

class SettingService {
    createRow(url, data) {
        let tok = localStorage.getItem('authUser')
        let token = JSON.parse(tok)

        const config = {
            headers: {
                'Authorization': "Token " + token.key
            },
        };

        return axios.post(url, data, config);
    };
    
    readRows(url) {
        let tok = localStorage.getItem('authUser')
        let token = JSON.parse(tok)

        const config = {
            headers: {
                'Authorization': "Token " + token.key
            },
        };
        return axios.get(url, config);
    };
    
    updateRow(url, oldData,newData) {
        let tok = localStorage.getItem('authUser')
        let token = JSON.parse(tok)

        const config = {
            headers: {
                'Authorization': "Token " + token.key
            },
        };

        return axios.put(url + oldData.id +'/', newData, config)
    };
    
    deleteRow(url, data) {
        let tok = localStorage.getItem('authUser')
        let token = JSON.parse(tok)

        const config = {
            headers: {
                'Authorization': "Token " + token.key
            },
        };

        return axios.delete(url + data.id + '/', config);
    };
}

export default new SettingService()